import { render, staticRenderFns } from "./AuctionFeed.vue?vue&type=template&id=e6e25bb8&scoped=true&"
import script from "./AuctionFeed.vue?vue&type=script&lang=js&"
export * from "./AuctionFeed.vue?vue&type=script&lang=js&"
import style0 from "./AuctionFeed.vue?vue&type=style&index=0&id=e6e25bb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6e25bb8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
